module.exports = __webpack_public_path__ + "img/p-1-1.9db69e44.jpg";